import React, { useEffect, useState } from 'react';
import { MDBRow } from 'mdb-react-ui-kit';

import {
    ClientAddresses, ClientCodeAndName, InvoiceShortLine,
    LabelAndColorDecimalValueContent, LabelAndValueContent
} from '../components/content/key-value-content.component';
import { ClientDataApi, ClientDebtApi, ClientFinancesApi } from '../api/api-client';
import { PrimaryBtn } from '../components/content/buttons.component';
import {
    CommonColCard4, CommonColCard6, DivTextCenter, LoadingDataWrapper
} from '../components/content/mdb-custom.component'


const StartPage = (props) => {
  const [data, setData] = useState({});
  const [debt, setDebt] = useState({});
  const [finances, setFinances] = useState({});
  let lines = [], kv_values = [], invoices = [], messages = [], last_payment = '';
  let last_payment_date;

  // https://www.robinwieruch.de/react-hooks-fetch-data/
  useEffect(() => {
    const fetchData = async () => {
      const result = await new ClientDebtApi().get();
      setDebt(result.data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const result = await new ClientDataApi().get();
      setData(result.data);
    }
    fetchData();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      const result = await new ClientFinancesApi().get();
      setFinances(result.data);
    }
    fetchData();
  }, [])

  // if data state is not empty
  if (Object.keys(data).length !== 0) {
      const compTranslations = {
          "Komputer": "Internet",
          "Telewizor": "Telewizja"
      };

      lines = data.active_computers.map((item, index) => {
          const serviceName = compTranslations[item.devicename] || item.devicename;
          return <LabelAndValueContent key={index} label={serviceName} value={item.tariff_name} />
      })

    const last_three_messages = data.clientmessage_set.sort((a, b) => {
      return b.id - a.id;
    }).slice(0, 3);

    const messages_final_form = last_three_messages.map((element) => {
      return [element.created.split('T')[0], element.short_desc];
    });

    messages = messages_final_form.map((item, index) => (
        <LabelAndValueContent key={index} label={item[0]} value={item[1]} />
    ));
  }

  // if debt state is not empty
  if (Object.keys(debt).length !== 0) {
      kv_values = [
          <LabelAndColorDecimalValueContent key="0" label="Saldo konta" value={debt.balance} currency="PLN" />,
          <LabelAndColorDecimalValueContent key="1" label="Zadłużenie" value={debt.debt_value} currency="PLN" />
      ]
  }

  if (Object.keys(finances).length !== 0) {
    const sorted_dates = finances.financial_documents.sort((a, b) => {
      return Date.parse(b.date) - Date.parse(a.date);
    });

    if (sorted_dates.length > 1) {
        invoices = sorted_dates.slice(0, 3).map((item, index) => (
            <InvoiceShortLine key={index} invoice={item} />
        ))
    }

    last_payment = sorted_dates.find(element => {
      if (element.codename === "WPL") {
        return element
      } return '';
    })

    // cannot do it in .find(). It can just return array content
      if (last_payment) {
          last_payment_date = <span>({last_payment.maturity})</span>;
          last_payment = <LabelAndColorDecimalValueContent label="Ostatnia wpłata" value={last_payment.brutto} currency="PLN" suffix={last_payment_date} />
      }
  }


  return (
      <>
          <MDBRow className='mt-5 mt-lg-0 pt-5 pt-lg-0 gx-5 align-items-stretch'>
              <CommonColCard4 cardTitle='Moje usługi'>
                  <LoadingDataWrapper waitingFor={data}>
                    {lines}
                  </LoadingDataWrapper>
                  <DivTextCenter>
                      <PrimaryBtn href="/services">Zobacz</PrimaryBtn>
                  </DivTextCenter>
              </CommonColCard4>
              <CommonColCard4 cardTitle='Faktury i wpłaty'>
                  <LoadingDataWrapper waitingFor={debt}>
                      {kv_values}
                  </LoadingDataWrapper>
                  <LoadingDataWrapper waitingFor={finances}>
                      {last_payment}
                      <hr className='hr hr-blurry' />
                      <h4 className='fw-bold text-center'>
                          Ostatnie faktury i wpłaty:
                      </h4>
                      {invoices}
                  </LoadingDataWrapper>
                  <DivTextCenter>
                      <PrimaryBtn href="/payments">Zobacz wszystkie</PrimaryBtn>
                  </DivTextCenter>
              </CommonColCard4>
              <CommonColCard4 cardTitle='Sprawdź oferty specjalnie dla Ciebie!'>
                  <DivTextCenter>
                      <PrimaryBtn href="https://korbank.pl/" target="_blank"
                                  className='mt-0 mt-lg-5'>
                          Zobacz
                      </PrimaryBtn>
                  </DivTextCenter>
              </CommonColCard4>
          </MDBRow>
          <MDBRow className='gx-5 align-items-stretch'>
              <CommonColCard6 cardTitle='Ostatnie wiadomości'>
                  <LoadingDataWrapper waitingFor={data}>
                      {messages}
                  </LoadingDataWrapper>
                  <DivTextCenter>
                      <PrimaryBtn href="/messages">Zobacz wszystkie</PrimaryBtn>
                  </DivTextCenter>
              </CommonColCard6>
              <CommonColCard6 cardTitle='Moje dane'>
                  <LoadingDataWrapper waitingFor={data}>
                      <ClientCodeAndName client_details={data} />
                      <ClientAddresses client_details={data} />
                  </LoadingDataWrapper>
                  <DivTextCenter>
                      <PrimaryBtn href="/account">Aktualizuj</PrimaryBtn>
                  </DivTextCenter>
              </CommonColCard6>
          </MDBRow>
      </>
  )
}

export { StartPage }
